import template from './cost_center.edit.html';
import controller from './cost_center.edit.controller';
import './cost_center.edit.scss';

let costCenterEditComponent = {
    restrict: 'E',
    bindings: {
        hasACL: '='
    },
    template,
    controller
};

export default costCenterEditComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_control/component/cost_center/edit/cost_center.edit.component.js